import { Injectable } from '@angular/core';
import { AppSettings } from '../../utils/app-settings';
import {
  ILoginRequest,
  IAuthResponse,
  ICheckPasswordRequest,
  IResetPasswordRequest,
  IChangePasswordRequest,
  IValidateCurrentPasswordRequest,
} from '../../interfaces/auth.interface';
import { IApiResponse } from '../../interfaces/api-response.interface';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  constructor(private appSettings: AppSettings, private http: HttpClient) {}

  login(request: ILoginRequest): Observable<IApiResponse<IAuthResponse>> {
    const { remember, ...rest } = request;
    const url = this.appSettings.auth.urls.postLogin;
    return this.http.post<IApiResponse<IAuthResponse>>(url, rest);
  }

  forgotPassword(
    request: ICheckPasswordRequest
  ): Observable<IApiResponse<IAuthResponse>> {
    const url = this.appSettings.auth.urls.postForgotPassword;
    return this.http.post<IApiResponse<IAuthResponse>>(url, request);
  }

  resetPassword(
    request: IResetPasswordRequest
  ): Observable<IApiResponse<IAuthResponse>> {
    const url = this.appSettings.auth.urls.patchResetPassword;
    return this.http.patch<IApiResponse<IAuthResponse>>(url, request);
  }

  validateCurrentPassword(
    request: IValidateCurrentPasswordRequest
  ): Observable<IApiResponse<{ valid: boolean }>> {
    const url = this.appSettings.auth.urls.postValidateCurrentPassword;
    return this.http.post<IApiResponse<{ valid: boolean }>>(url, request);
  }

  changePassword(
    request: IChangePasswordRequest
  ): Observable<IApiResponse<IAuthResponse>> {
    const url = this.appSettings.auth.urls.postChangePassword;
    return this.http.post<IApiResponse<IAuthResponse>>(url, request);
  }

  logout(): Observable<IApiResponse<IAuthResponse>> {
    const url = this.appSettings.auth.urls.postLogout;
    return this.http.post<IApiResponse<IAuthResponse>>(url, {});
  }
}
